export const darkThemeColors = {
  backgroundcolor: "#101713",
  rowColor: "#0a0a0a",
  txt_color: "#bbb",
  tablecreateTheme: "#0f0f0f",
  activeColor: "#2b8a54",
  imageFill: "black",
  StrokeColor: "#0f0f0f",
};

export const lightThemeColors = {
  backgroundcolor: "#385a47",
  rowColor: "#F2F2F2",
  txt_color: "#191919",
  tablecreateTheme: "#D9D9D9",
  activeColor: "#2b8a54",
  imageFill: "#FFFFFF",
  StrokeColor: "#B8B8B8",
};
